import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import Menu from "../../components/Menu";
import { useCallback, useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import Loading from "../../components/Loading";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import api from "../../services/api";
import { confirmDialog } from "primereact/confirmdialog";

export function CadastroQualidade() {
    const OPTIONS_FOR_TYPE = [
        { label: "Geral", value: '1' },
        { label: "Turma", value: '2' },
        { label: "Grupo", value: '3' }
    ];

    // 1 - Geral
    // 2 - Turma
    // 3 - Grupo

    const [data, setData] = useState([]);
    const [form, setForm] = useState({
        "min": 0,
        "max": 0,
        "premio": 0,
        "tipo": 0
    });

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => {
        toast.current.show({
            summary: 'Ocorreu um Erro',
            severity: 'error',
            detail: error.response ? error.response.data.message : error.message
        });
    }

    const showSuccess = (response) => {
        toast.current.show({
            summary: 'Sucesso',
            severity: 'success',
            detail: response.data.message
        });
    }

    const format = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(rowData[props.field]) + '%';
    }

    const changeVisibility = _ => {
        setIsVisible(!isVisible);
    }

    const handleDelete = rowData => {
        confirmDialog({
            acceptLabel: "Excluir",
            acceptClassName: "p-button-danger",
            rejectLabel: "Cancelar",
            rejectClassName: "p-button-secondary",
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            accept: () => {
                setIsLoading(true);
                api.delete(`qualidade/${rowData.id}/delete`).then((response) => {
                    getData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const handleEdit = rowData => {
        setForm({
            "qualidade_id": rowData.id,
            "min": rowData.min,
            "max": rowData.max,
            "premio": rowData.premio,
            "tipo": rowData.tipo
        });
        setIsEditing(true);
        setIsVisible(true);
    }

    const handleUpdate = _ => {
        if(isEditing) {
            setIsLoading(true);
            api.put("qualidade/update", form).then((response) => {
                getData();
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                setIsEditing(false);
                showError(error);
            });
        } else {
            setIsLoading(true);
            api.post("qualidade", {
                "min": form.min,
                "max": form.max,
                "premio": form.premio,
                "tipo": form.tipo
            }).then((response) => {
                getData();
                setIsLoading(false);                
                showSuccess(response)
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const getData = useCallback(() => {
        setIsLoading(true);
        api.get("qualidade").then((response) => {
            setIsLoading(false);
            setData(response.data);
        }).catch((error) => {
            setIsLoading(false);
             
        });
    }, []);

    useEffect(() => {
        getData();
    }, [getData]);

    if(isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />

            <Dialog
                header="Qualidade"
                onHide={changeVisibility}
                style={{ minWidth: "30vw" }}
                visible={isVisible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="">Tipo: </label>
                        <Dropdown
                            className="p-m-1"
                            onChange={e => setForm({...form, tipo:  e.value })}
                            options={OPTIONS_FOR_TYPE}
                            placeholder="Escolha um Tipo..."
                            value={form.tipo}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="">Mínimo: </label>
                        <InputNumber 
                            maxFractionDigits={3}
                            minFractionDigits={3}
                            onValueChange={e => setForm({...form, min: e.value}) }
                            placeholder="Exemplo: 1,161%"
                            value={form.min}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="">Máximo: </label>
                        <InputNumber 
                            maxFractionDigits={3}
                            minFractionDigits={3}
                            onValueChange={e => setForm({...form, max: e.value}) }
                            placeholder="Exemplo: 1,220%"
                            value={form.max}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="">Prêmio: </label>
                        <InputNumber 
                            maxFractionDigits={3}
                            minFractionDigits={3}
                            onValueChange={e => setForm({...form, premio: e.value}) }
                            placeholder="Exemplo: 16%"
                            value={form.premio}
                        />
                    </div>
                    <div className="p-d-flex p-flex-row">
                        <Button className="p-button-secondary p-mr-6" label="Cancelar" onClick={changeVisibility} />
                        <Button className="p-button-success" label="Salvar" onClick={() => handleUpdate()} />
                    </div>
                </div>
            </Dialog>

            <Card
                className="p-m-1"
                title="Controle de Qualidade - Tecelagem"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button className="p-m-1 p-ml-auto" icon="pi pi-plus" onClick={changeVisibility} />
                </div>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    groupRowsBy="tipof"
                    onRowClick={(props) => handleEdit(props.data)}
                    rowGroupHeaderTemplate={(rowData) => (
                        <h3 className="p-m-4">{rowData.tipof}</h3>
                    )}
                    rowGroupMode="subheader"
                    rowHover
                    stripedRows
                    size="small"
                    value={data}
                >
                    <Column header="Mínimo" field="min" body={format} />
                    <Column header="Máximo" field="max" body={format} />
                    <Column header="Prêmio" field="premio" />
                    <Column header="Excluir" body={(rowData) => (
                        <Button className="p-button-danger" icon="pi pi-trash" onClick={() => handleDelete(rowData)} />
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}